import { Link } from 'react-router';
import s from './app.module.css';
import { t } from '@/shared/i18n';

export function NotFoundPage() {
  return (
    <main className={s.center}>
      <h1>{t('Страница не найдена')}</h1>
      <p>{t('Возможно, ссылка устарела или канал удалили.')}</p>
      <Link to="/">{t('На главную')}</Link>
    </main>
  );
}
